var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C2.40371 8.2895 5.82701 15.312 9.83327 23.0736L13.2481 22.042C8.99371 15.5775 5.50499 10.1522 4.30735 3.20354L7.30963 3.98264C8.84317 13.2792 17.2156 20.4329 20.8414 24.7619C21.4491 26.7821 20.9144 28.8023 20.2323 30.4761C26.6276 33.5707 33.2014 37.5718 40.4646 39.0476C43.1922 36.9258 45.949 35.6292 48.9055 40L50.1239 36.5367L52.9956 36.4502L51.3856 32.9439C54.1575 33.9355 57.6222 30.9653 57.6947 30.13C57.9022 27.7353 57.7561 26.2638 59 24.3292L52.0818 25.2815C51.9124 27.2864 52.2779 29.5679 50.2109 30.736C39.2529 36.9286 35.9233 23.0451 36.8967 17.2295C32.3921 15.254 31.8172 12.9196 29.1519 8.83129L26.3672 8.48489L24.4528 10.13L19.4926 3.80969L0 0Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/mexico.f167a1f071bb209f8aa47538f9d4645b.svg";
export { ForwardRef as ReactComponent };